export enum QuestionType {
  ShortAnswer,
  SelectMany,
  SelectOne,
  SelectManyWithLimit
}
